import styled from 'styled-components/macro';

export const NavigationTabWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 48px;
`;
